<template>
  <b-collapse v-model="visible" class="mt-1">
    <slot></slot>
  </b-collapse>
</template>

<script>
export default {
  name: "bootstrap-collapse",
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  }
};
</script>

<style></style>
